/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-18 10:08:20
 * @LastEditors: 陈钊贤
 * @Description: 
 * @LastEditTime: 2020-06-19 19:24:47
 */ 

const SET_DATA = 'SET_DATA';
const state = {
  token: null,
  phone: null,
  oprPkId: null,
  userObject: null,
  accountObj: null,
};

// 同步操作 是变更参数的方法
const mutations = {
  [SET_DATA](state, status) {
    state.token = status.token || state.token;
    state.phone = status.phone || state.phone;
    state.oprPkId = status.oprPkId || state.oprPkId;
    console.log(state);
  },
  SET_USEROBJ(state, data) {
    state.userObject = data
  },
  SET_ACCOUNTOBJ(state, data) {
    state.accountObj = data
  },
};

export default {
  state,
  mutations,
};
